import React, {
    useEffect,
    useRef,
    useState,
    useContext,
    useCallback,
} from "react";
import { getOrderDetails } from "../api/apiCalls";
import {
    Paper,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
} from "@mui/material";
import { MonitorHeart } from "@mui/icons-material";
import GlobalContext from "../contexts/globalcontext";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const ClosedOrders = ({ openOrders }) => {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const dbGotData = useRef(true);
    const { sbAlert, setAuth, auth } = useContext(GlobalContext);
    const firstLoad = useRef(true);
    const [missingOrders, setMissingOrders] = useState([]);
    const [dbOrders, setDBOrders] = useState([]);

    const SaveOpenOrderstoDB = async () => {
        // console.log("Orders Save to DB");
        try {
            const response = await axiosPrivate.post(
                `/data/orders/${auth.username}`,
                JSON.stringify(openOrders)
            );
            // console.log(response);
            sbAlert(response.data.message, "success");
            setDBOrders(openOrders);
            setMissingOrders([]);
        } catch (err) {
            console.log(err);
            if (err.response?.status === 403) {
                setAuth({});
                navigate("/");
            }
        }
    };

    const checkOrders = async () => {
        //Check the old orders to see which are missings in the current orders and get their status.
        let tmpCloseOrders = [];
        // console.log("1", dbOrders);
        // console.log("2", openOrders);
        for (let i = 0; i < dbOrders.length; i++) {
            let found = false;
            for (let j = 0; j < openOrders.length; j++) {
                // console.log(dbOrders[i].order_id, openOrders[j].order_id);
                if (dbOrders[i].order_id === openOrders[j].order_id) {
                    found = true;
                }
            }
            if (!found) {
                const tmpStatus = await getOrderDetails(dbOrders[i].order_id);
                // console.log(dbOrders[i], tmpStatus);
                tmpCloseOrders.push({
                    ...dbOrders[i],
                    status: tmpStatus.status,
                });
            }
        }
        setMissingOrders(tmpCloseOrders);
    };

    useEffect(() => {
        // console.log("Run Order Comparison");
        const saveData = async () => {
            console.log("Save Data");
            await SaveOpenOrderstoDB();
        };
        if (openOrders.length !== 0 && !dbGotData.current) saveData();
        checkOrders();
    }, [openOrders]);

    const getDBOpenOrders = useCallback(async () => {
        try {
            const response = await axiosPrivate.get(
                `/data/orders/${auth.username}`
            );
            // console.log("data", response?.data[0]?.dbvalue);
            if (response?.data[0]?.dbvalue) {
                if (response?.data[0]?.dbvalue.length !== 0) {
                    setDBOrders(response?.data[0]?.dbvalue);
                } else dbGotData.current = false;
            } else dbGotData.current = false;
        } catch (err) {
            console.log(err);
            if (err.response?.status === 403) {
                setAuth({});
                navigate("/");
            }
        }
    }, []);

    useEffect(() => {
        if (firstLoad.current === true) {
            getDBOpenOrders();
            firstLoad.current = false;
        }
    }, [getDBOpenOrders]);

    return (
        <div>
            <TableContainer
                component={Paper}
                sx={{ minWidth: 400, maxWidth: 650 }}
                elevation={5}
            >
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={5}>
                                <Typography variant="h6">
                                    <span>
                                        Historical Orders (
                                        {missingOrders.length})
                                    </span>
                                    <span>
                                        <Button
                                            onClick={SaveOpenOrderstoDB}
                                            startIcon={<MonitorHeart />}
                                        >
                                            Clear and Monitor Current Orders
                                        </Button>
                                    </span>
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" width="100px">
                                Side
                            </TableCell>
                            <TableCell align="left">Crypto Name</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">Qty</TableCell>
                            <TableCell align="center">Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {missingOrders.map((order) => (
                            <TableRow key={order.order_id}>
                                <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                >
                                    {order.side === "BUY" ? (
                                        <Chip
                                            label={order.side}
                                            sx={{ width: "80px" }}
                                            color="success"
                                            size="small"
                                        />
                                    ) : (
                                        <Chip
                                            label={order.side}
                                            sx={{ width: "80px" }}
                                            color="error"
                                            size="small"
                                        />
                                    )}
                                </TableCell>
                                <TableCell align="left">
                                    {order.instrument_name}
                                </TableCell>
                                <TableCell align="right">
                                    {order.price}
                                </TableCell>
                                <TableCell align="right">
                                    {order.quantity}
                                </TableCell>
                                <TableCell align="center">
                                    {order.status}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default ClosedOrders;
